module.exports = __webpack_public_path__ + "static/media/buzzme.8baf9616.png";